<template>
  <div>
    <div style="text-align: left; background-color: #EFF3FF; padding-left: 10px; padding-top: 1px; padding-bottom: 5px; font-size: 16px">
      <p style="font-size: 20px; font-weight: bold">加密和解密</p>
      <p>密码术意味着更改消息的文本，以便不知道你秘密的人永远不会理解你的消息。</p>
      <p>下面就来创建一个GUI应用程序，使用Python进行加密和解密。
        在这里，我们需要编写使用无限循环的代码，代码将不断询问用户是否要加密或解密消息。</p>

    </div>
    <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 10px">

      <div style="width: 800px;  text-align: left; color: white; font-size: 15px; line-height: 25px; ">
        <div style="color: white; text-align: left; font-weight: bold">示例代码：</div>
        <div style="padding: 10px; background-color: rgb(43, 43, 43); margin-top: 5px;  height: 650px; overflow-y: auto">
          <div>

<pre><code ># -*- coding: utf-8 -*-
"""
Created on Thu Oct 12 22:15:58 2023


@author: liuxijuan
"""


from tkinter import messagebox, simpledialog, Tk

def is_even(number):
    return number % 2 == 0

def get_even_letters(message):
    even_letters = []
    for counter in range(0, len(message)):
        # 判断counter是否可被2整除  <span v-if="showAnswer" style="color: #dd6161">答案： is_even(counter):</span>
        if <input type="text" v-model="yourAnswer1" style="width: 200px"></input>
            even_letters.append(message[counter])
    return even_letters

def get_odd_letters(message):
    odd_letters = []
    for counter in range(0, len(message)):
        if not is_even(counter):
            # 向odd_letters插入message指定字符 <span v-if="showAnswer" style="color: #dd6161">答案： odd_letters.append(message[counter])</span>
            <input type="text" v-model="yourAnswer2" style="width: 300px"></input>
    return odd_letters

def swap_letters(message):
    letter_list = []
    if not is_even(len(message)):
        message = message + 'x'
    even_letters = get_even_letters(message)
    odd_letters = get_odd_letters(message)
    for counter in range(0, int(len(message) / 2)):
        letter_list.append(odd_letters[counter])
        letter_list.append(even_letters[counter])
    new_message = ''.join(letter_list)
    return new_message

def get_task():
    task = simpledialog.askstring('任务', '你是否想要加密或解密信息?')
    return task

def get_message():
    message = simpledialog.askstring('信息', '输入相关信息: ')
    return message

root = Tk()
while True:
    task = get_task()
    if task == '加密':
        # 将 get_message() 的返回值赋值给message <span v-if="showAnswer" style="color: #dd6161">答案： get_message()</span>
        <input type="text" v-model="yourAnswer3" style="width: 200px"></input>
        encrypted = swap_letters(message)
        messagebox.showinfo('密电的密文为:', encrypted)


    elif task == '解密':
        message = get_message()
        decrypted = swap_letters(message)
        messagebox.showinfo('密电的明文为:', decrypted)

    else:
        break

root.mainloop()


</code></pre><p><br></p>
          </div>
        </div>
      </div>
      <div style="width: calc(100vw - 950px);  text-align: left;  font-size: 15px; line-height: 25px; ">
        <div
          style="color: white; text-align: left; font-weight: bold; display: flex; justify-content: space-between; align-items: center">
          <span>
            运行效果：
          </span>
          <el-button type="success" @click="runCode">运行</el-button>
        </div>
        <div style="padding: 10px; background-color: white; margin-top: 5px; height: 600px;">
          <div style="padding: 10px; display: flex; justify-content: center; margin-top: 100px">
            <div style="width: 300px; height: 200px">
              <div v-if="step === 1">
                你是否想要加密或解密信息?
                <el-select v-model="jmType" placeholder="请选择" style="width: 100%">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div style="text-align: center; padding: 5px">
                  <el-button @click="okStep1">OK</el-button>
                  <el-button @click="step = 0">Cancel</el-button>
                </div>
              </div>
              <div  v-if="step === 2">
                请输入相关信息:
                <el-input v-model="inputMsg" placeholder="请输入内容"></el-input>
                <div style="text-align: center; padding: 5px">
                  <el-button @click="okStep2">OK</el-button>
                  <el-button @click="step = 0">Cancel</el-button>
                </div>
              </div>
              <div style="width: 100px; height: 100px"  v-if="step === 3">
                <i class="el-icon-info"></i> 加解密后：{{result}}
                <div style="text-align: center; padding: 5px">
                  <el-button @click="finish">确定</el-button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { addExpScore } from '../../request/api';

  export default {
    data() {
      return {
        //words: ['pizza', 'fairy', 'teeth', 'shirt', 'otter', 'plane'],
        words: ['otter'],
        chooseWord: '',
        showWordArray: [],
        word: [],
        guess: '',
        chances: 3,
        message: '',
        zcdCode: [],
        inputVal: '',
        jmType: '加密',
        inputMsg: '',
        outputMsg: '',
        step: 0,
        options: [{
          value: '加密',
          label: '加密'
        },{
          value: '解密',
          label: '解密'
        }],
        value: '加密',
        answer1: 'is_even(counter):',
        answer2: 'odd_letters.append(message[counter])',
        answer3: 'get_message()',
        answer4: '',
        answer5: '',
        yourAnswer1: '',
        yourAnswer2: '',
        yourAnswer3: '',
        yourAnswer4: '',
        yourAnswer5: '',
        haveSubmit: false,
        showAnswer: false,
        task: '',
        isEncrypting: false,
        isDecrypting: false,
        result: ''
      };
    },
    created() {
      this.chooseWord = this.words[Math.floor(Math.random() * this.words.length)];

      this.word = this.chooseWord.split('');
      this.showWordArray = new Array();
      for (let i = 0; i < this.word.length; i++) {
        this.showWordArray.push("?");
      }
    },
    methods: {
      runCode() {
        if (this.yourAnswer1 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer2 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer3 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }


        let totalScore = 0;
        let fin = 1;
        if (this.answer1 === this.yourAnswer1) {
          totalScore += 40;
        } else {
          fin = 0;
        }
        if (this.answer2 === this.yourAnswer2) {
          totalScore += 30;
        } else {
          fin = 0;
        }
        if (this.answer3 === this.yourAnswer3) {
          totalScore += 30;
        } else {
          fin = 0;
        }
        /*if (this.answer4 === this.yourAnswer4) {
          totalScore += 25;
        } else {
          fin = 0;
        }*/

        if (fin === 0) {
          this.showAnswer = true;

          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "加密和解密"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
            this.$message.warning("请根据正确答案填充好缺失,再次运行");
            console.log("这里出来吗")
          }
        } else {
          console.log("这里出来吗aaaa")
          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "加密和解密"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
          }
          this.step = 1
          this.getTask();

        }

      },
      okStep1() {

        this.step++
      },
      okStep2() {
        this.executeTask()
        this.step++
      },
      finish() {
        this.step = 1
        this.inputMsg = ''
        this.result = ''
      },
      getTask() {

        if (this.jmType === '加密') {
          this.isEncrypting = true;
        } else if (this.jmType === '解密') {
          this.isDecrypting = true;
        }
      },
      executeTask() {
        if (this.isEncrypting) {
          this.result = this.swapLetters(this.inputMsg);
        } else if (this.isDecrypting) {
          this.result = this.swapLetters(this.inputMsg);
        }
        console.log("是否加密：" + this.isDecrypting)
      },
      isEven(number) {
        return number % 2 === 0;
      },
      getEvenLetters(message) {
        const evenLetters = [];
        for (let counter = 0; counter < message.length; counter++) {
          if (this.isEven(counter)) {
            evenLetters.push(message[counter]);
          }
        }
        return evenLetters;
      },
      getOddLetters(message) {
        const oddLetters = [];
        for (let counter = 0; counter < message.length; counter++) {
          if (!this.isEven(counter)) {
            oddLetters.push(message[counter]);
          }
        }
        return oddLetters;
      },
      swapLetters(message) {
        let letterList = [];
        if (!this.isEven(message.length)) {
          message = message + 'x';
        }
        const evenLetters = this.getEvenLetters(message);
        const oddLetters = this.getOddLetters(message);
        for (let counter = 0; counter < Math.floor(message.length / 2); counter++) {
          letterList.push(oddLetters[counter]);
          letterList.push(evenLetters[counter]);
        }
        const newMessage = letterList.join('');
        return newMessage;
      }

    },
  };
</script>



// WEBPACK FOOTER //
// src/components/lw/sz03.vue